module.exports = __webpack_public_path__ + "static/media/icon-new.71caee33.woff";